import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApiError, BaseFormList, MessageService } from '../../../core';
import { CondicaoPagamentoPrazo } from './condicao-pagamento-prazo';
import { CondicaoPagamentoPrazoCalculoService } from './services';


@Component({
    selector: 'sgt-condicao-pagamento-prazo',
    templateUrl: './condicao-pagamento-prazo.component.html',
    styleUrls: ['./condicao-pagamento-prazo.component.less']
})
export class CondicaoPagamentoPrazoComponent implements BaseFormList<CondicaoPagamentoPrazo> {
    @Input() entities: CondicaoPagamentoPrazo[];
    @Input() prazoMedio: number;
    @Output() prazoMedioChange = new EventEmitter<number>();


    constructor(private messageService: MessageService,
                private condicaoPagamentoPrazoCalculoService: CondicaoPagamentoPrazoCalculoService) { }

    /** Calcula o prazo médio dos prazos da condição de pagamento  */
    private calcularPrazoMedio() {
        this.prazoMedio = this.condicaoPagamentoPrazoCalculoService.calcularPrazoMedio(this.entities);
        this.prazoMedioChange.emit(this.prazoMedio);
    }

    /** Ao alterar o prazo médio no input */
    onChangePrazoMedio() {
        this.prazoMedioChange.emit(this.prazoMedio);
    }

    onChangePrazo() {
        this.calcularPrazoMedio();
    }

    insert() {
        const entity = new CondicaoPagamentoPrazo();
        this.entities.push(entity);
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir esse prazo?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
                this.calcularPrazoMedio();
            }
        });
    }

    /** Verifica se os prazos da condição estão válidos */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.prazo) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.prazo && entityFilter.prazo === entity.prazo).length;
            if (count > 1) {
                this.messageService.info(`O prazo ${entity.prazo} já está adicionado. Remova ou altere o prazo duplicado`, 'Não é possível adicionar dois prazos iguais');
                return false;
            }
        }
        return true;
    }

    /** Resolve os prazos presentes na condição */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os prazos do array que não possuirem o prazo informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];
            if (entity.prazo == null || entity.prazo === undefined) {
                this.entities.splice(i, 1);
            }
        }
    }
}
